// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"f2a23ba4","67":"18e2b4e3","86":"0fd2a8f4","151":"c929a8d0","179":"b382d9cb","198":"b289dd03","241":"154f1065","372":"1e0cdd3f","763":"43ce2a65","815":"b6917624","851":"998e41f3","898":"c4880a1a","907":"15e9afc9","953":"51c63dba"}[chunkId] + ".chunk.js";
};